import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=56be59ae&scoped=true"
import script from "./Checkout.vue?vue&type=script&lang=ts"
export * from "./Checkout.vue?vue&type=script&lang=ts"
import style0 from "./Checkout.vue?vue&type=style&index=0&id=56be59ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56be59ae",
  null
  
)

export default component.exports